/*
 * Copyright (c) 2017, Indigen Solutions. All rights reserved.
 *
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 *
 * This software is the confidential and proprietary information.
 *
 * You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement
 * you entered into.
 */

import printJS from "print-js";
import axios from "../../node_modules/axios";

/**
 *
 */
export class PDFHelper {

    public show(url) {
        window.open(url);
    }

    public print(url) {
        printJS(url);
    }

    public download(url, filename: string) {
        let link = document.createElement("a");
        link.href = url;        
        link.download = filename;
        link.click();
    }

    public async getBase64Content(url: string) {
        const result = await axios.request({
            responseType: "arraybuffer",
            url: url,
            method: "get",
            headers: {
                "Content-Type": "application/pdf",
            },
        });
        const base64content = await this.blobToBase64(new Blob([result.data], { type: "application/pdf" }));
        return base64content;
    }

    protected blobToBase64(blob: any) {
        return new Promise((resolve) => {
            var reader = new FileReader();
            reader.onload = function () {
                var dataUrl = reader.result;
                var base64 = dataUrl.split(",")[1];
                resolve(base64);
            };
            reader.readAsDataURL(blob);
        });
    }  

}



// WEBPACK FOOTER //
// ./src/helper/PDF.helper.ts